// src/components/EmailCollect.jsx
import { useState } from 'react';
export default function EmailCollect() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();
    setMessage({ text: '', type: '' });
    setLoading(true);

    if (!email || !email.includes('@')) {
      setMessage({ text: 'Please enter a valid email address.', type: 'error' });
      setLoading(false);
      return;
    }
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    try {
      const res = await fetch(baseUrl + "/api/v1/beta/register", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      
      if (!res.ok) {
        setMessage({ text: `❌ ${data.error?.message || 'Unknown error'}`, type: 'error' });
      } else {
        setMessage({ text: '✅' + data.data.message, type: 'success' });
        setEmail('');
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setMessage({ text: '❌ Something went wrong. Please try again later.', type: 'error' });
    }

    setLoading(false);
  };

  return (
    <section id="subscribe" className="py-24 px-6 bg-[#1e293b] text-white relative overflow-hidden">
      {/* Purple radial glow */}
      <div className="absolute inset-x-0 z-0 flex justify-center -translate-y-1/2 pointer-events-none top-1/2">
        <div className="w-[400px] h-[300px] bg-violet-600/20 rounded-full blur-3xl"></div>
      </div>

      {/* Email form card */}
      <div className="relative z-10 max-w-xl mx-auto text-center">
        <div className="p-10 border shadow-lg bg-white/5 border-white/10 rounded-2xl backdrop-blur-md">
          <h2 className="mb-4 text-3xl font-bold">Get Early Access to InvokeApi</h2>
          <p className="mb-6 text-lg text-gray-300">
            Join the beta to receive your personal API token and try InvokeApi hosted tools
          </p>

          <form id="emailForm" onSubmit={handleSubmit} className="flex flex-col justify-center gap-4 sm:flex-row">
            <input
              id="emailInput"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full sm:w-auto px-4 py-3 rounded-md bg-[#0f172a] text-white border border-white/10 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-violet-500"
              required
            />
            <button
              type="submit"
              className="px-6 py-3 text-sm font-semibold transition rounded-md bg-violet-600 hover:bg-violet-500"
            >
              Join Early Access
            </button>
          </form>

          {/* Feedback message */}
          {message.text && (
            <p
              id="emailMessage"
              className={`text-sm mt-4 ${message.type === 'success' ? 'text-green-400' : 'text-red-400'}`}
            >
              {message.text}
            </p>
          )}

          <p className="mt-4 text-sm text-gray-400">
            You’ll receive access to your API toolbox and be the first to know when we launch new tools
            like PDF parsing, audio transcription, and more.
          </p>
        </div>
      </div>
    </section>
  );
}
